export enum DISPATCH_NOTES_CONFIRMATION_STEPS {
    DELIVERY = 'delivery',
    LOAD_PLACE = 'loadPlace',
    TRANSPORT = 'transport',
    RECEPTION = 'reception',
    OTHERS = 'others',
};
